import { defineStore } from 'pinia'

export const useSearchUsersStore = defineStore('search-users', {
    state: () => ({ 
        isHistory: false, 
        listSelected: [],
        criterias: [],
        expandedCriterias: { activities: [], skills: [] },
        usersFound: [],
    }),

    getters: {
        IsHistory: (state) => state.isHistory,
        ListSelected: (state) => state.listSelected,
        Criterias: (state) => state.criterias,
        ExpandedCriterias: (state) => state.expandedCriterias,
        UsersFound: (state) => state.usersFound,
    },

    actions: {
        mergeRequestIntoFinal(finalList, requestList) {
            const finalMap = new Map(finalList.map(p => [p.id, p]));

            for (const reqParent of requestList) {
                const finalParent = finalMap.get(reqParent.id);

                if (!finalParent) {
                    // Parent doesn't exist → add full object from request
                    finalList.push(structuredClone(reqParent));
                    continue;
                }

                // Ensure children array exists in final
                if (!Array.isArray(finalParent.children)) {
                    finalParent.children = [];
                }

                const finalChildIds = new Set(finalParent.children.map(c => c.id));

                // Add missing children
                for (const reqChild of reqParent.children || []) {
                    if (!finalChildIds.has(reqChild.id)) {
                        finalParent.children.push(structuredClone(reqChild));
                    }
                }
            }

            return finalList;
        },

        SetHistoryData(list) {
            this.setIsHistory(true)
            this.listSelected = list
        },

        setIsHistory(value) {
            this.isHistory = value
        },

        setCriterias(value) {
            this.criterias = value
        },

        setExpandedCriterias(value) {
            this.expandedCriterias = value
        },

        setUsersFound(value) {
            this.usersFound = value
        },

        ResetHistoryData() {
            this.setIsHistory(false)
            this.listSelected = []
        },

        ResetSearchUsers() {
            this.expandedCriterias = { activities: [], skills: [] }
            this.usersFound = []
        }
    }
})
